import styled from "styled-components";

export const Label = styled.label`
  margin-bottom: ${props => props.theme.spacerlg};
  font-size: ${props => props.theme.largeFontSize};
`;
